import { Intent } from '@Components/designConstants';
import { InstanceAdvertiser } from './amc-instances-types';

export const filterAdvertisers = (
  advertisers: InstanceAdvertiser[],
  query: string
): InstanceAdvertiser[] => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return advertisers;
  return advertisers.filter(advertiser =>
    [advertiser.name, advertiser.id, advertiser.type].some(field =>
      field?.toLowerCase().includes(trimmed)
    )
  );
};

// Dry-run vs live wording, so each action only has to describe itself once.
export const modeLabel = (label: string, live: boolean): string =>
  `${label} (${live ? 'LIVE' : 'dry-run'})`;

export const modeNote = (live: boolean): string =>
  live
    ? 'LIVE mode — this will be sent to the real Tinuiti AMC account on Amazon.'
    : 'Dry-run only — this is validated without changing anything on Amazon.';

export const writeSuccess = (live: boolean, action: string, liveNote = '') => ({
  title: live ? 'Sent to Amazon' : 'Dry-run complete',
  message: live
    ? `${action}. ${liveNote}`.trim()
    : `${action} (dry run). Nothing was changed on Amazon.`,
  intent: Intent.SUCCESS,
  hideCancel: true
});
